import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { PaginatedList, AppResult } from '../../../models';
import { environment } from '../../../../../environments/environment';
import { RoleModel, RoleSearchModel, CreateRoleModel, UpdateRoleModel, PremissionModel, AssignRoleModel } from '../../../models/auths';

const IT_API_URL = `${environment.apiUrl}/api/Roles`;

@Injectable({
   providedIn: 'root',
})
export class RoleHTTPService {
   constructor(private readonly http: HttpClient) { }

   // public methods
   Search(model: RoleSearchModel): Observable<PaginatedList<RoleModel>> {
      const httpOptions = {
         headers: { 'Content-Type': 'application/json' },
         params: {
            page: model.page,
            pageSize: model.pageSize,
            userName: model.userName ?? ''
         }
      };
      return this.http.get<PaginatedList<RoleModel>>(`${IT_API_URL}`, httpOptions);
   }

   GetRole(roleName: string): Observable<RoleModel> {
      return this.http.get<RoleModel>(`${IT_API_URL}/${roleName}`);
   }

   GetRolesNotInUser(userName: string): Observable<RoleModel[]> {
      return this.http.get<RoleModel[]>(`${IT_API_URL}/GetRolesNotInUser/${userName}`);
   }

   GetPremissions(): Observable<PremissionModel[]> {
      return this.http.get<PremissionModel[]>(`${IT_API_URL}/GetPremissions/`);
   }

   AddRole(model: CreateRoleModel): Observable<AppResult<RoleModel>> {
      return this.http.post<AppResult<RoleModel>>(`${IT_API_URL}`, model);
   }

   AssignRole(model: AssignRoleModel): Observable<AppResult<string>> {
      return this.http.post<AppResult<string>>(`${IT_API_URL}/AssignRole`, model);
   }

   UpdateRole(model: UpdateRoleModel): Observable<AppResult<RoleModel>> {
      return this.http.put<AppResult<RoleModel>>(`${IT_API_URL}`, model);
   }

   DeleteRole(roleName: string): Observable<AppResult<string>> {
      return this.http.delete<AppResult<string>>(`${IT_API_URL}/${roleName}`);
   }
}
